import { render, staticRenderFns } from "./CartTotalNav.vue?vue&type=template&id=6ebd5a06"
import script from "./CartTotalNav.vue?vue&type=script&lang=js"
export * from "./CartTotalNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports